import CRUDFormComponent from '../../components/CRUDFormComponent'

const SurgeriesForm = () => {
  const fields = [{ key: 'name', label: 'Nombre', type: 'string' }]

  return (
    <>
      <CRUDFormComponent
        entityName={{ singular: 'Cirugías' }}
        fields={fields}
        entityUrl="/surgeries"
      />
    </>
  )
}

export default SurgeriesForm
